import React from 'react';
import styled from 'styled-components';
import { IoInformationCircle } from 'react-icons/io5';

// Please delete after this message is not needed anymore (few weeks after 5th June 2024)

const CreditCardBanMessage = () => {
	const isPastExpiryDate = true;

	return (
		<Message $isPastExpiryDate={isPastExpiryDate}>
			<IoInformationCircle size={14} />
			<p>
				{isPastExpiryDate
					? 'Due to new government legislation, we can no longer accept deposits from credit cards. We recommend providing a new payment method and then removing any credit cards from your saved payment methods for any future deposits.'
					: 'Due to new government legislation, we will not accept deposits from credit cards from 5th June 2024. We recommend providing a debit card or other payment method now to ensure seamlessness with any future deposits.'}
			</p>
		</Message>
	);
};

export default CreditCardBanMessage;

const Message = styled.div<{ $isPastExpiryDate: boolean }>`
	display: flex;
	background-color: ${({ $isPastExpiryDate }) => ($isPastExpiryDate ? '#cd3024' : '#de7e00')};
	font-size: 12px;
	line-height: 14px;
	padding: 10px;
	gap: 5px;
	color: #fff;
	text-align: left;
	font-weight: 500;
	border-radius: 4px;
	margin-bottom: 10px;

	svg {
		flex-shrink: 0;
		margin-top: 5px;
	}
`;
